// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAZd7CC6iFqJowKSLE0AHEbuQSeU1iQkOE",
  authDomain: "wayne-alumni.firebaseapp.com",
  projectId: "wayne-alumni",
  storageBucket: "wayne-alumni.firebasestorage.app",
  messagingSenderId: "189586242437",
  appId: "1:189586242437:web:54ff096843dd163ef822ec"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage};